module.exports = __webpack_public_path__ + "img/aboutus.f7d6caee.png";